import React, { useEffect, useState, createContext } from "react";
import { toast } from "react-toastify";
import useList from "../controller/list-controller";
import { getCookie } from "../utils/session";

export const ConstListContext = createContext();

export const ConstListContextProvider = ({ children }) => {
  const fsoId = getCookie("fsoId");
  const { allConst, getConstants, isLoading, errMsg } = useList();
  const [isLoader, setIsLoader] = useState(true);
  const [constData, setConstData] = useState({});

  useEffect(() => {
    getConstants({
      accountId: "",
      fsoId,
      objectName: "List View",
    });
  }, []);

  useEffect(() => {
    setIsLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  useEffect(() => {
    if (allConst) {
      setConstData(allConst);
    }
  }, [allConst]);

  return (
    <ConstListContext.Provider
      value={{
        isLoader,
        constData,
      }}
    >
      {children}
    </ConstListContext.Provider>
  );
};
